import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { ExternalLink } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0B0F0E] border-t border-[#52ea88]/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-[7.6923%] py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3 group">
              <img 
                src="https://customer-assets.emergentagent.com/job_filmanalyzer/artifacts/ak5g8xbg_My%20Logo.png" 
                alt="Matrix Film Review Logo" 
                className="h-9 w-auto object-contain"
              />
              <span className="text-[#E6FFF6] font-semibold text-lg">
                {t('footer.brand')}
              </span>
            </Link>
            <p className="text-[#9FBFB4] text-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-[#E6FFF6] font-semibold text-sm uppercase tracking-wider">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-3">
              <Link
                to="/"
                className="text-[#9FBFB4] hover:text-[#E6FFF6] transition-colors text-sm"
              >
                {t('nav.home')}
              </Link>
              <Link
                to="/reviews"
                className="text-[#9FBFB4] hover:text-[#E6FFF6] transition-colors text-sm"
              >
                {t('nav.reviews')}
              </Link>
              <Link
                to="/editorial"
                className="text-[#9FBFB4] hover:text-[#E6FFF6] transition-colors text-sm"
              >
                {t('nav.editorial')}
              </Link>
              <Link
                to="/categories"
                className="text-[#9FBFB4] hover:text-[#E6FFF6] transition-colors text-sm"
              >
                {t('nav.categories')}
              </Link>
            </nav>
          </div>

          {/* Movie Matrix Universe */}
          <div className="space-y-4">
            <h4 className="text-[#E6FFF6] font-semibold text-sm uppercase tracking-wider">
              Movie Matrix Universe
            </h4>
            <nav className="flex flex-col gap-3">
              <a
                href="https://moviematrixtrailers.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#9FBFB4] hover:text-[#52ea88] transition-colors text-sm flex items-center gap-2"
              >
                {t('footer.links.trailers')}
                <ExternalLink className="w-3 h-3" />
              </a>
              <a
                href="https://www.youtube.com/@TheMovieMatrixTV"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#9FBFB4] hover:text-[#52ea88] transition-colors text-sm flex items-center gap-2"
              >
                {t('footer.links.tv')}
                <ExternalLink className="w-3 h-3" />
              </a>
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#52ea88]/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-[#9FBFB4] text-sm">
            © {currentYear} Matrix Film Review. {t('footer.rights')}.
          </p>
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 bg-[#52ea88] animate-pulse rounded-full"></span>
            <span className="text-[#9FBFB4] text-xs">System Online</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
